export const SUPPORT_EMAIL = "appsupport@fasterwaytofatloss.com";
